<template>
  <div class="tag-anchor" :style="styles" :id="$attrs._id">
    <div 
      class="tag-line"
      :style="lineStyle"
    ></div>
    <div 
      v-if="tailPosition !== 'none'"
      class="tag-dot"
    ></div>
    <div 
      class="tag-action"
      :class="[
        `tag-action--${type}`
      ]"
      ref="el"
      :style="labelStyle"
      @click="triggerAction"
    >
      <fa :icon="icon" fixed-width />
      <div class="tag-action__ring"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['action', 'background-colour', 'icon', 'label', 'pos', 'tail-height', 'tail-position', 'type'],

  computed: {
    styles () {
      return {
        left: `${(this.pos.x / 20)}em`,
        top: `${(this.pos.y / 20)}em`,
      }
    },

    labelStyle () {
      let tailStyles = {}
      switch (this.tailPosition) {
        case 'none':
          tailStyles = {
            transform: `translate(-50%, -50%)`
          }
          break
        
        case 'bottom-left':
          tailStyles = {
            bottom: '0',
            transform: `translate(-1em, -${this.tailHeight * 1.33}em)`
          }
          break

        case 'bottom-center':
          tailStyles = {
            bottom: '0',
            left: '50%',
            transform: `translate(-50%, -${this.tailHeight * 1.33}em)`
          }
          break

        case 'bottom-right':
          tailStyles = {
            bottom: '0',
            right: '0',
            transform: `translate(1em, -${this.tailHeight * 1.33}em)`
          }
          break

        case 'top-left':
          tailStyles = {
            transform: `translate(-1em, ${this.tailHeight * 1.33}em)`
          }
          break

        case 'top-center':
          tailStyles = {
            left: '50%',
            transform: `translate(-50%, ${this.tailHeight * 1.33}em)`
          }
          break

        case 'top-right':
          tailStyles = {
            right: '0',
            transform: `translate(1em, ${this.tailHeight * 1.33}em)`
          }
          break

        case 'left-center':
          tailStyles = {
            left: '0',
            top: '.125em',
            transform: `translate(${this.tailHeight * 1.33}em, -50%)`
          }
          break

        case 'right-center':
          tailStyles = {
            right: '0',
            top: '.125em',
            transform: `translate(-${this.tailHeight * 1.33}em, -50%)`
          }
          break
      
        default:
          return ''
      }

      let colorStyles = {}
      if (this.backgroundColour && this.backgroundColour !== '#ffffff') {
        colorStyles = {
          backgroundColor: this.backgroundColour
        }
      }

      return Object.assign(colorStyles, tailStyles)
    },

    lineStyle () {
      switch (this.tailPosition) {
        case 'none':
          return `display: none;`
        
        case 'bottom-left':
          return `
            height: ${this.tailHeight}em;
            transform: translateY(-${this.tailHeight}em);
            z-index: 6;
          `

        case 'bottom-center':
          return `
            height: ${this.tailHeight}em;
            transform: translateY(-${this.tailHeight}em);
            z-index: 6;
          `

        case 'bottom-right':
          return `
            height: ${this.tailHeight}em;
            transform: translateY(-${this.tailHeight}em);
            z-index: 6;
          `

        case 'top-left':
          return `
            bottom: 0;
            height: ${this.tailHeight}em;
            transform: translateY(${this.tailHeight}em);
          `

        case 'top-center':
          return `
            bottom: 0;
            height: ${this.tailHeight}em;
            transform: translateY(${this.tailHeight}em);
          `

        case 'top-right':
          return `
            bottom: 0;
            height: ${this.tailHeight}em;
            transform: translateY(${this.tailHeight}em);
          `

        case 'left-center':
          return `
            height: .25em;
            right: 0;
            top: -.125em;
            width: ${this.tailHeight}em;
            transform: translateX(0);
            z-index: 6;
          `

        case 'right-center':
          return `
            height: .25em;
            left: 0;
            top: -.125em;
            width: ${this.tailHeight}em;
            transform: translateX(-${this.tailHeight}em);
            z-index: 6;
          `
      
        default:
          return ''
      }
    },
  },

  methods: {
    triggerAction () {
      if (this.action && this.action.method) {
        this.$store.dispatch(`actions/${this.action.method}`, {
          payload: this.action.payload,
          virtualTourUrl: this.$attrs.virtualTourUrl,
          tag: { 
            icon: this.icon,
            label: this.label,
            backgroundColour: this.backgroundColour
          },
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";


.tag-anchor {
  color: $action-tag-bg-color;
  font-size: 1em;
  opacity: 0;
  position: absolute;
  pointer-events: none;
  z-index: 5;

  &.enter {
    opacity: 1;
    animation: bounce-in 1s 1;
  }

  &.leave {
    opacity: 0;
    transition: opacity 0.3s;
  }
}

.tag-dot {
  background: $white;
  border-radius: 50%;
  bottom: -.25em;
  height: .5em;
  left: -.25em;
  pointer-events: auto;
  position: absolute;
  width: .5em;
}

.tag-line {
  background: $white;
  left: -.125em;
  pointer-events: auto;
  position: absolute;
  width: .25em;
}

.tag-action {
  align-items: center;
  background-color: $action-tag-bg-color;
  border: .35em solid #fff;
  border-radius: $action-tag-border-radius;
  box-shadow: $tag-box-shadow;
  color: $action-tag-font-color;
  display: flex;
  font-size: $action-tag-font-size;
  font-weight: 400;
  height: 4.5em;
  justify-content: center;
  line-height: 1.1;
  padding: 1em;
  pointer-events: auto;
  position: absolute;
  user-select: none;
  width: 4.5em;

  svg {
    height: 100%;
    width: 100%;
  }

  &__ring {
    border: 0.2rem solid currentColor;
    border-radius: 4rem;
    height: 2.6rem;
    width: 2.6rem;
    position: absolute;
    left: 50%;
    top: 50%;
    animation: pulsate 2s ease-out;
    animation-iteration-count: infinite; 
    opacity: 0.0;
    z-index: -1;
  }
}
</style>
